export default __webpack_public_path__ + "locales/sk/Profile.json?hash=2ecc9c2514033362878db57d93ced67d";